import type { IByggKontraktGaranti } from './IByggKontraktGaranti';

export class ByggKontraktGaranti implements IByggKontraktGaranti {
    public static parseObject(obj: IByggKontraktGaranti): ByggKontraktGaranti {
        try {
            return new ByggKontraktGaranti(obj);
        } catch (error) {
            throw new Error(
                `Not able to parse KontraktGaranti object, object attempted to parse is: ${JSON.stringify(
                    obj,
                )}`,
            );
        }
    }

    public get amount() {
        return this._amount;
    }
    public get byggNummer() {
        return this._byggNummer;
    }
    public get kontraktId() {
        return this._kontraktId;
    }
    public get garantiId() {
        return this._garantiId;
    }
    public get garantiNummer() {
        return this._garantiNummer;
    }
    public get klassifiseringstype() {
        return this._klassifiseringstype;
    }

    private _amount: number;
    private _byggNummer: string;
    private _garantiId: number;
    private _garantiNummer: string;
    private _kontraktId: string;
    private _klassifiseringstype: string;

    constructor(obj: IByggKontraktGaranti) {
        this._amount = obj.amount;
        this._byggNummer = obj.byggNummer;
        this._kontraktId = obj.kontraktId;
        this._garantiId = obj.garantiId;
        this._garantiNummer = obj.garantiNummer;
        this._klassifiseringstype = obj.klassifiseringstype;
    }
}
